import { createSelector } from "reselect";
import { AppState } from "src/shared/interfaces/State.interface";

const selectUser = (state: AppState) => state.user;

export const getUsers = () => createSelector(selectUser, (state) => state.users);
export const getUsersTotal = () => createSelector(selectUser, (state) => state.usersTotal);
export const getUser = () => createSelector(selectUser, (state) => state.user);
export const getFilter = () => createSelector(selectUser, (state) => state.filter);
